var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHamburgerMenu = function SvgHamburgerMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    fill: "none",
    viewBox: "0 0 66 66"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#72226D",
    d: "M0 0h66v66H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "closed-lines",
    fill: "white",
    d: "M13 20h40v-2H13v2Zm0 14h40v-2H13v2Zm0 14h40v-2H13v2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "open-lines",
    fill: "white",
    d: "M19.7 48 48 19.7l-1.42-1.4-28.29 28.28 1.42 1.41Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "open-lines",
    fill: "white",
    d: "m18.47 19.85 28.29 28.28 1.41-1.41-28.28-28.29-1.42 1.42Z"
  })));
};
export default SvgHamburgerMenu;